import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "g-container" }

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'xk',
  setup(__props) {

const moveAnimationDuration = ref("12s");
const fadeAnimationDuration = ref("12s");

const groupStyle = (delay: number) => {
  return {
    animationDelay: `${delay}s`,
  };
};

const itemStyle = (delay: number) => {
  return {
    animationDelay: `${delay}s`,
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "g-group",
        style: _normalizeStyle(groupStyle(0))
      }, _cache[0] || (_cache[0] = [
        _createStaticVNode("<div class=\"item-right\" data-v-66880b26></div><div class=\"item-left\" data-v-66880b26></div><div class=\"item-top\" data-v-66880b26></div><div class=\"item-bottom\" data-v-66880b26></div><div class=\"item-middle\" data-v-66880b26></div>", 5)
      ]), 4),
      _createElementVNode("div", {
        class: "g-group",
        style: _normalizeStyle(groupStyle(-6))
      }, [
        _createElementVNode("div", {
          class: "item-right",
          style: _normalizeStyle(itemStyle(-6))
        }, null, 4),
        _createElementVNode("div", {
          class: "item-left",
          style: _normalizeStyle(itemStyle(-6))
        }, null, 4),
        _createElementVNode("div", {
          class: "item-top",
          style: _normalizeStyle(itemStyle(-6))
        }, null, 4),
        _createElementVNode("div", {
          class: "item-bottom",
          style: _normalizeStyle(itemStyle(-6))
        }, null, 4),
        _createElementVNode("div", {
          class: "item-middle",
          style: _normalizeStyle(itemStyle(-6))
        }, null, 4)
      ], 4)
    ])
  ]))
}
}

})